import React from "react";
import clsx from "clsx";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

const Tooltip = () => {

  const questionView = useSelector( state => state.questionView );

  const { t } = useTranslation();

  return (
    <div className={ clsx( 'viewopen-toast', 'toast-pop', 'gm', 2 === questionView.tooltipStatus && 'disappear' ) }>
      <div className="viewopen-toast-inner">
        <p dangerouslySetInnerHTML={ { __html : t( 'LC_05_20.msg017' ) } } />
      </div>
    </div>
  );

};

export default Tooltip;
